import React, { ReactNode } from "react"

export type HeadingTextProps = {
  children?: ReactNode
  level: 1 | 2 | 3 | 4 | 5 | 6
  className?: string
  id?: string
}
const HeadingText = ({ level, children, className, id }: HeadingTextProps) => {
  const Tag: React.ElementType = `h${level}`

  switch (level) {
    case 1:
      return <Tag id={id} className={`mb-5 text-5xl font-extrabold ${className}`}>{children}</Tag>
    case 2:
      return <Tag id={id} className={`text-3xl font-bold lg:text-4xl ${className}`}>{children}</Tag>
    case 3:
      return <Tag id={id} className={`text-lg font-bold ${className}`}>{children}</Tag>
    case 4:
      return <Tag id={id} className={`line-clamp-1 font-bold ${className}`}>{children}</Tag>
    default: {
      return <Tag id={id} className={`line-clamp-1 font-bold ${className}`}>{children}</Tag>
    }
  }
}

export { HeadingText }
